<template>
  <Card>
    <template #title="">
      <div class="p-d-flex p-justify-between">
        รายงานรายละเอียดการฝึกอบรม
        <div>
          <BackButton></BackButton>
        </div>
      </div>
    </template>
    <template #content="">
      <div class="p-grid">
        <div class="p-col-12 p-lg-4 p-md-6 p-fluid p-field">
          <span class="p-float-label">
            <Calendar
              selectionMode="range"
              v-model="query.selectedDate"
              id="selectedDate"
            ></Calendar>
            <label for="selectedDate">ระบุวันที่ต้องการดึงข้อมูล</label>
          </span>
        </div>
        <div class="p-col-12 p-lg-4 p-md-6 p-fluid p-field">
          <span class="p-float-label">
            <InputCourse
              v-model="query.courseId"
              id="inputCourse"
              showClear
            ></InputCourse>
            <label for="inputCourse">ระบุหลักสูตร</label>
          </span>
        </div>
        <div class="p-col-12 p-lg-4 p-md-6 p-fluid p-field">
          <span class="p-float-label">
            <InputQuestion
              v-model="query.questionId"
              id="questionId"
              showClear
            ></InputQuestion>
            <label for="questionId">ระบุแบบประเมิน</label>
          </span>
        </div>
        <div class="p-col-12 p-lg-4 p-md-6 p-fluid p-field">
          <span class="p-float-label">
            <InputUser
              v-model="query.userId"
              id="inputUser"
              showClear
            ></InputUser>
            <label for="inputUser">ระบุพนักงาน</label>
          </span>
        </div>
      </div>
    </template>
    <template #footer="">
      <Button
        label="Download Excel"
        icon="pi pi-table"
        @click="downloadReport"
      />
    </template>
  </Card>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { usePlugin } from "@/plugins";
import { useSessionStorage } from "@vueuse/core";
import InputCourse from "@/components/InputCourse.vue";
import InputUser from "@/components/InputUser.vue";
import InputQuestion from "@/components/InputQuestion.vue";
import { GetTrainingReportRequest } from "@/types";
import { saveAs } from "file-saver";

export default defineComponent({
  name: "TrainingReport",
  components: { InputCourse, InputUser, InputQuestion },
  setup() {
    const { setLoading, dayjs, axios, success, error } = usePlugin();
    const query = useSessionStorage("trainingReport-query", {
      courseId: null,
      userId: null,
      questionId: null,
      selectedDate: [
        dayjs()
          .startOf("month")
          .toDate(),
        dayjs()
          .endOf("month")
          .toDate(),
      ],
    });
    query.value.selectedDate[0] = dayjs(query.value.selectedDate[0]).toDate();
    query.value.selectedDate[1] = dayjs(query.value.selectedDate[1]).toDate();

    const downloadReport = async () => {
      setLoading(true);
      try {
        const result = await axios.post(
          "api/v1/services/report/training",
          {
            selectedDate: query.value.selectedDate,
            questionId: query.value.questionId,
            courseId: query.value.courseId,
            employeeId: query.value.userId,
          } as GetTrainingReportRequest,
          {
            responseType: "blob",
            timeout: 300000,
            timeoutErrorMessage: "หมดเวลาการเชื่อมต่อ กรุณาลองใหม่ภายหลัง",
          }
        );

        saveAs(result.data);

        success("ดึงข้อมูลสำเร็จแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    return {
      query,
      downloadReport,
    };
  },
});
</script>

<style></style>
